module.exports = __webpack_public_path__ + "assets/img/zh2.5e815d6e.png";